import { Component, OnInit } from '@angular/core';
import { EmailConfigurationService } from '../../services'; 
import { SharedService } from 'src/app/shared/services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.css']
})
export class SendEmailComponent implements OnInit {
   
  responsemessage;
  constructor(
    private emailConfigurationService:EmailConfigurationService,
    public sharedService : SharedService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this.checkViewPermission();
  }

  SendEmail(){
    this.emailConfigurationService.SendEmail().subscribe((data: any) => {
      if(data==true)
      {
        this.responsemessage="Email sent successfully"
      }
      else
      {
        this.responsemessage="Something went wrong.Please try again later."
      }
    });
  }

  AddRequisition(){
    this.emailConfigurationService.AddRequisitionDueExpiry().subscribe((data: any) => {
      if(data==true)
      {
        this.responsemessage="Requisition Due expiry Details added Successufully"
      }
      else
      {
        this.responsemessage="Something went wrong.Please try again later."
      }
    });
  }

  checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }

}
